import { ButtonHTMLAttributes, memo } from 'react';
import classes from './styles.module.scss';
import clsx from 'clsx';

interface PrimaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  fullWidth?: boolean;
  onClick?: (...args: any) => void;
  [key: string]: any;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = memo((props: PrimaryButtonProps) => {
  const { children, className, style, fullWidth, onClick, ...rest } = props;

  return (
    <button className={clsx(classes.container, className, { [classes.fullWidth]: fullWidth })} style={style} onClick={onClick} {...rest}>
      {children}
    </button>
  );
});

export default PrimaryButton;
